// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Activity.proto" (package "aware", syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../google/protobuf/duration";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Geolocation } from "./Location";
/**
 * These are general categories used by the engine to represent classes of activities.
 * See Aware Engine's README for more details.
 *
 * @generated from protobuf enum aware.ActivityCategoryType
 */
export var ActivityCategoryType;
(function (ActivityCategoryType) {
    /**
     * @generated from protobuf enum value: Sleep = 0;
     */
    ActivityCategoryType[ActivityCategoryType["Sleep"] = 0] = "Sleep";
    /**
     * @generated from protobuf enum value: Movement = 1;
     */
    ActivityCategoryType[ActivityCategoryType["Movement"] = 1] = "Movement";
    /**
     * @generated from protobuf enum value: InteractingAgent = 2;
     */
    ActivityCategoryType[ActivityCategoryType["InteractingAgent"] = 2] = "InteractingAgent";
    /**
     * @generated from protobuf enum value: ComputerUsage = 3;
     */
    ActivityCategoryType[ActivityCategoryType["ComputerUsage"] = 3] = "ComputerUsage";
    /**
     * @generated from protobuf enum value: PhysicalWork = 4;
     */
    ActivityCategoryType[ActivityCategoryType["PhysicalWork"] = 4] = "PhysicalWork";
    /**
     * @generated from protobuf enum value: Eating = 5;
     */
    ActivityCategoryType[ActivityCategoryType["Eating"] = 5] = "Eating";
    /**
     * @generated from protobuf enum value: Exercise = 6;
     */
    ActivityCategoryType[ActivityCategoryType["Exercise"] = 6] = "Exercise";
    /**
     * @generated from protobuf enum value: SelfCare = 7;
     */
    ActivityCategoryType[ActivityCategoryType["SelfCare"] = 7] = "SelfCare";
})(ActivityCategoryType || (ActivityCategoryType = {}));
/**
 * @generated from protobuf enum aware.TransitMode
 */
export var TransitMode;
(function (TransitMode) {
    /**
     * @generated from protobuf enum value: Unspecified = 0;
     */
    TransitMode[TransitMode["Unspecified"] = 0] = "Unspecified";
    /**
     * Stay in place
     *
     * @generated from protobuf enum value: None = 1;
     */
    TransitMode[TransitMode["None"] = 1] = "None";
    /**
     * @generated from protobuf enum value: Walk = 2;
     */
    TransitMode[TransitMode["Walk"] = 2] = "Walk";
    /**
     * @generated from protobuf enum value: Bike = 3;
     */
    TransitMode[TransitMode["Bike"] = 3] = "Bike";
    /**
     * @generated from protobuf enum value: Drive = 4;
     */
    TransitMode[TransitMode["Drive"] = 4] = "Drive";
    /**
     * @generated from protobuf enum value: Rideshare = 5;
     */
    TransitMode[TransitMode["Rideshare"] = 5] = "Rideshare";
    /**
     * @generated from protobuf enum value: Bus = 6;
     */
    TransitMode[TransitMode["Bus"] = 6] = "Bus";
    /**
     * @generated from protobuf enum value: Subway = 7;
     */
    TransitMode[TransitMode["Subway"] = 7] = "Subway";
    /**
     * @generated from protobuf enum value: Train = 8;
     */
    TransitMode[TransitMode["Train"] = 8] = "Train";
    /**
     * @generated from protobuf enum value: Fly = 9;
     */
    TransitMode[TransitMode["Fly"] = 9] = "Fly";
})(TransitMode || (TransitMode = {}));
/**
 * @generated from protobuf enum aware.TransitInfoSource
 */
export var TransitInfoSource;
(function (TransitInfoSource) {
    /**
     * @generated from protobuf enum value: UnspecifiedTransitInfoSource = 0;
     */
    TransitInfoSource[TransitInfoSource["UnspecifiedTransitInfoSource"] = 0] = "UnspecifiedTransitInfoSource";
    /**
     * @generated from protobuf enum value: Valhalla = 1;
     */
    TransitInfoSource[TransitInfoSource["Valhalla"] = 1] = "Valhalla";
    /**
     * @generated from protobuf enum value: Mapbox = 2;
     */
    TransitInfoSource[TransitInfoSource["Mapbox"] = 2] = "Mapbox";
    /**
     * @generated from protobuf enum value: AwareEngineEstimate = 3;
     */
    TransitInfoSource[TransitInfoSource["AwareEngineEstimate"] = 3] = "AwareEngineEstimate";
})(TransitInfoSource || (TransitInfoSource = {}));
// @generated message type with reflection information, may provide speed optimized methods
class ActivityCategoryEstimate$Type extends MessageType {
    constructor() {
        super("aware.ActivityCategoryEstimate", [
            { no: 1, name: "activity_vector", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityEstimate }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityCategoryEstimate
 */
export const ActivityCategoryEstimate = new ActivityCategoryEstimate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityEstimate$Type extends MessageType {
    constructor() {
        super("aware.ActivityEstimate", [
            { no: 1, name: "activity_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "activity_confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityEstimate
 */
export const ActivityEstimate = new ActivityEstimate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransitInfo$Type extends MessageType {
    constructor() {
        super("aware.TransitInfo", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start_location", kind: "message", T: () => Geolocation },
            { no: 3, name: "end_location", kind: "message", T: () => Geolocation },
            { no: 4, name: "transit_mode", kind: "enum", T: () => ["aware.TransitMode", TransitMode] },
            { no: 5, name: "departure_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "retrieved_time", kind: "message", T: () => Timestamp },
            { no: 7, name: "duration", kind: "message", T: () => Duration },
            { no: 8, name: "source", kind: "enum", T: () => ["aware.TransitInfoSource", TransitInfoSource] },
            { no: 9, name: "route_polyline", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.TransitInfo
 */
export const TransitInfo = new TransitInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityCooccurrencePrior$Type extends MessageType {
    constructor() {
        super("aware.ActivityCooccurrencePrior", [
            { no: 1, name: "activity_type_a", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "activity_type_b", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "correlation", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityCooccurrencePrior
 */
export const ActivityCooccurrencePrior = new ActivityCooccurrencePrior$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetectionToActivityPrior$Type extends MessageType {
    constructor() {
        super("aware.DetectionToActivityPrior", [
            { no: 1, name: "detection_class_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "activity_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "activity_likelihood", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DetectionToActivityPrior
 */
export const DetectionToActivityPrior = new DetectionToActivityPrior$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityTypeHierarchyLink$Type extends MessageType {
    constructor() {
        super("aware.ActivityTypeHierarchyLink", [
            { no: 1, name: "parent_activity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "child_activity", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityTypeHierarchyLink
 */
export const ActivityTypeHierarchyLink = new ActivityTypeHierarchyLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityDistributeProbabilityPrior$Type extends MessageType {
    constructor() {
        super("aware.ActivityDistributeProbabilityPrior", [
            { no: 1, name: "parent_activity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "child_activities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityDistributeProbabilityPrior
 */
export const ActivityDistributeProbabilityPrior = new ActivityDistributeProbabilityPrior$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityDetectionPriorKnowledge$Type extends MessageType {
    constructor() {
        super("aware.ActivityDetectionPriorKnowledge", [
            { no: 1, name: "known_activity_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "detection_to_activity_priors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DetectionToActivityPrior },
            { no: 3, name: "activity_cooccurrence_priors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityCooccurrencePrior },
            { no: 4, name: "activity_type_hierarchy_links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityTypeHierarchyLink },
            { no: 5, name: "activity_distribute_probability_priors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityDistributeProbabilityPrior },
            { no: 100, name: "object_detection_classes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "sound_detection_classes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityDetectionPriorKnowledge
 */
export const ActivityDetectionPriorKnowledge = new ActivityDetectionPriorKnowledge$Type();
/**
 * @generated ServiceType for protobuf service aware.FakeServiceActivity
 */
export const FakeServiceActivity = new ServiceType("aware.FakeServiceActivity", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
